import EmptyBlock, { EmptyBlockProps } from './EmptyBlock';

export type { EmptyBlockProps };
export default EmptyBlock;
